export const devConsole = {
  info: (...args: Parameters<typeof console.info>) => {
    if (process.env.GATSBY_ENV === 'dev') {
      // eslint-disable-next-line no-console
      console.info(...args);
    }
  },
  error: (...args: Parameters<typeof console.error>) => {
    if (process.env.GATSBY_ENV === 'dev') {
      console.error(...args);
    }
  },
  warn: (...args: Parameters<typeof console.warn>) => {
    if (process.env.GATSBY_ENV === 'dev') {
      // eslint-disable-next-line no-console
      console.warn(...args);
    }
  },
  debug: (...args: Parameters<typeof console.debug>) => {
    if (process.env.GATSBY_ENV === 'dev') {
      // eslint-disable-next-line no-console
      console.debug(...args);
    }
  },
  log: (...args: Parameters<typeof console.log>) => {
    if (process.env.GATSBY_ENV === 'dev') {
      // eslint-disable-next-line no-console
      console.log(...args);
    }
  },
};
